<template lang="pug">
component(:is="layout")
</template>

<script>
import { mapState } from "vuex"
import defaultLayout from "./default.vue"
import ihgLayout from "./ihg.vue"

export default {
  name: "home",
  computed: {
    layout() {
      return this.config["home_layout.home_layout"] === "ihg" ? ihgLayout : defaultLayout
    },
    ...mapState(["config"])
  }
}
</script>
